import {
  Component,
  Inject,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { GridOptions } from 'ag-grid-community';

@Component({
  selector: 'app-of-error-dialog',
  templateUrl: './of-error-dialog.component.html',
  styleUrls: ['./of-error-dialog.component.scss'],
})
export class OfErrorDialogComponent  {
  editEventEmitter = new EventEmitter();
  rowData: any;
  @ViewChild('osPartsGrid') osPartsGrid;
  columnDefs;
  defaultColDef;
  rowSelection;

  gridOptions!: GridOptions;
  paginationPageSize;
  paginationNumberFormatter;
  pagination = false;
  context: any;
  editType;
  suppressClickEdit = true;

  editEnabled: boolean = false;
  freezeStatus: boolean = false;

  adjCodeList: any = [];
  editform: FormGroup = this.formBuilder.group({
    adjCode: [[]],
    adjReason: ['', Validators.required],
  });
  editFormcontrol = this.editform.controls;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly formBuilder: FormBuilder,
    private readonly dialogRef: MatDialogRef<OfErrorDialogComponent>
  ) {
    this.columnDefs = [
      {
        headerName: 'Van DT',
        headerTooltip: 'Vanning Date(mm/dd/yyyy)',
        field: 'vanning_date',
        sortable: true,
        width: 100,
      },
      {
        headerName: 'Part No',
        field: 'item_id',
        sortable: true,
        width: 110,
      },
      {
        headerName: 'CC',
        headerTooltip: 'Container Code',
        field: 'cont_code',
        width: 75,
      },
      {
        headerName: 'Man Adj',
        field: 'adj_qty',
        width: 100,
      },
      {
        headerName: 'Adj Reason',
        field: 'adj_reason',
        width: 130,
      },
      {
        headerName: 'Remarks',
        field: 'remarks',
        width: 238,
        headerComponentParams: {
          template:
            '<span class="ag-header-cell-text" style="color:#D20000">Error</span>',
        },
        cellStyle: {
          color: '#D20000',
        },
        cellRenderer: (params) => {
          const html = params.value
            .split('\r\n')
            .map((line) => `<li style="list-style-type:none;">${line}</li>`)
            .join('\n');
          return `${html}`;
        },
      },
    ];
    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.paginationPageSize = data.modifiedRowData.length;
    this.rowData = data.modifiedRowData.map((row) => {
      return { ...row, remarks: row.remarks?.v ?? '' };
    });
    this.adjCodeList = data.adjCodeList;
    this.getGridOptions();
  }

  getGridOptions() {
    this.gridOptions = {} as any;

    this.gridOptions.headerHeight = 38;

    this.gridOptions.rowHeight = 28;
    this.gridOptions.floatingFiltersHeight = 0;

    this.gridOptions.rowBuffer = 20;
    this.gridOptions.suppressMovableColumns = true;
    // this.gridOptions.domLayout = 'autoHeight';
    // this.gridOptions.suppressRowClickSelection = true;
    // this.gridOptions.enableCellTextSelection = true;
    // this.gridOptions.suppressCopyRowsToClipboard = true;
    // this.gridOptions.enableRangeSelection = true;
    // this.gridOptions.rowSelection = 'single';
    this.gridOptions.enableCellTextSelection = true;
    this.gridOptions.suppressContextMenu = false;
    this.gridOptions.suppressClipboardPaste = true;

    this.gridOptions.defaultColDef = {
      sortable: true,
      suppressMenu: true,
      filter: false,
      floatingFilter: false,

      wrapText: true,
      autoHeight: true,
      // suppressSizeToFit: true,
      // headerClass: 'grid-header-class',
      // cellStyle(params) {
      //   return {
      //     'line-height': '36px',
      //   };
      // },

      suppressPaste: false,

      floatingFilterComponentParams: { suppressFilterButton: true },
      unSortIcon: true,
      icons: {
        sortUnSort: '<img src="../../../assets/images/Rectangle8.svg">',
      },
      filterParams: {
        textCustomComparator(filter, value, filterText) {
          const filterTextLoweCase = filterText.toLowerCase();

          let valueLowerCase = '';
          if (value.params) {
            valueLowerCase = value.value.toString().toLowerCase();
          } else {
            valueLowerCase = value.toString().toLowerCase();
          }
          function contains(target, lookingFor) {
            if (target === null) {
              return false;
            }
            return target.indexOf(lookingFor) >= 0;
          }
          return contains(valueLowerCase, filterTextLoweCase);
        },

        // Debounce time - Delay before Floating filter search
        debounceMs: 1000,

        caseSensitive: true,
        suppressAndOrCondition: true,
        inRangeInclusive: true,
      },
    };

    return this.gridOptions;
  }


  submitted: boolean = false;
  saveChanges(): any {
    if (this.editform.invalid) {
      this.submitted = true;
      return;
    }

    const addEmittedData = {
      adjCode: 'MAN',
      adjReason: this.editform.value.adjReason,
    };

    this.editEventEmitter.emit(addEmittedData);
    this.dialogRef.close();
  }
}
